import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';

import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { ConfirmProvider } from './contexts/ConfirmContext';

import Login from './pages/Login';
import Start from './pages/Start';
import Datei from './pages/Datei';
import Dateien from './pages/Dateien';
import Fragen from './pages/Fragen';
import Laufwerk from './pages/Laufwerk';
import Admin from './pages/Admin';
import BetreiberKonsole from './pages/BetreiberKonsole';
import Profil from './pages/Profil';

// Gestaltung und Grundaufbau nach powerCONTACT: ohne SIP, ohne AgentsLoader,
// ohne OIDC-Callback-Seite — der Login-Rueckweg landet beim Backend, das das
// Session-Cookie setzt und auf die App weiterleitet.

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

// admin.* = Betreiber-Konsole (Mandantenverwaltung), kein Firmen-Arbeitsplatz (Christian 08.09.)
export const istAdminPortal = typeof window !== 'undefined' && window.location.hostname.startsWith('admin.');

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Router>
          <BrandingProvider>
          <AuthProvider>
            <ConfirmProvider>
              <ScrollToTop />
              <Routes>
                <Route path="/login" element={<Login />} />
                {istAdminPortal ? (
                  <Route path="/*" element={<ProtectedRoute><BetreiberKonsole /></ProtectedRoute>} />
                ) : (
                <Route path="/*" element={
                  <ProtectedRoute>
                    <div className="min-h-screen bg-gray-50">
                      <Layout>
                        <Routes>
                          <Route path="/" element={<Start />} />
                          <Route path="/fragen" element={<Fragen />} />
                          <Route path="/fragen/:id" element={<Fragen />} />
                          {/* Suchseite seit 23.10. ersetzt durch „Fragen“ — alte Links landen dort */}
                          <Route path="/suche" element={<Navigate to="/fragen" replace />} />
                          <Route path="/datei/:id" element={<Datei />} />
                          <Route path="/dateien" element={<Dateien />} />
                          <Route path="/laufwerk" element={<Laufwerk />} />
                          <Route path="/admin" element={<Admin />} />
                          <Route path="/profil" element={<Profil />} />
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                      </Layout>
                    </div>
                  </ProtectedRoute>
                } />
                )}
              </Routes>
              <Toaster position="top-right"
                toastOptions={{ duration: 4000, style: { background: '#363636', color: '#fff' } }} />
            </ConfirmProvider>
          </AuthProvider>
          </BrandingProvider>
        </Router>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
